import React from "react";
import { Button, CardActions, Divider, Grid } from "@material-ui/core";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { Truck } from "react-feather";
import CardStatus from "../../components/CardStatus";
import CardDashboard from "../../components/CardDashboard";
import { useTranslation } from "react-i18next";

const SupportCard = ({ supports, action }) => {
  const { t } = useTranslation();

  const notActive = supports.filter((obj) => obj.is_active === false).length;
  const active = supports.filter((obj) => obj.is_active === true).length;

  return (
    <CardDashboard
      title={t("support_card.title")}
      value={supports.length}
      avatar={<Truck />}
      action={
        action ? (
          <>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                endIcon={<ArrowRightIcon />}
                onClick={action}
              >
                {t("support_card.action")}{" "}
              </Button>
            </CardActions>
          </>
        ) : null
      }
    >
      <Grid container style={{ paddingTop: "1.25rem" }}>
        <Grid item xs={6}>
          <CardStatus
            type="down"
            title={t("support_card.not_active")}
            value={notActive}
          />
        </Grid>
        <Grid item xs={6}>
          <CardStatus
            type="up"
            title={t("support_card.active")}
            value={active}
          />
        </Grid>
      </Grid>
    </CardDashboard>
  );
};

export default SupportCard;
